module.exports = {
      id: "steps-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "assets/img/sprite-8cafc1.svg#steps-usage",
      toString: function () {
        return this.url;
      }
    }